import React, { useState } from 'react';
import { motion } from 'framer-motion';
import './PoliticalWins.css';

const PoliticalWinsPage = () => {
  // State for modal
  const [selectedStory, setSelectedStory] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  // State for flip cards
  const [flippedCards, setFlippedCards] = useState({});

  // Victory stories data
  const victoryStories = [
    {
      id: 1,
      title: "हर्रैया: रणनीति और नेतृत्व से मिली निर्णायक जीत",
      location: "हर्रैया, उत्तर प्रदेश",
      year: "2022",
      description: "2022 के उत्तर प्रदेश विधानसभा चुनाव में, बस्ती जिले की हर्रैया सीट पर भारतीय जनता पार्टी (भाजपा) के उम्मीदवार श्री अजय सिंह की जीत, एक बहु-कोणीय मुकाबले और जटिल जातिगत समीकरणों को सफलतापूर्वक पार करने वाली एक महत्वपूर्ण विजय थी।",
      metrics: [
        { label: "वोट प्राप्त", value: "88,200" },
        { label: "वोटों से जीत", value: "18,329" },
        { label: "मत प्रतिशत", value: "40.2%" }
      ],
      fullDetails: {
        challenge: "बहु-कोणीय मुकाबले और जटिल जातिगत समीकरणों को सफलतापूर्वक पार करना",
        strategy: [
          "प्रभावी चुनावी रणनीति",
          "जमीनी स्तर पर मजबूत नेतृत्व",
          "लक्षित मतदाता अभियान",
          "सामाजिक मीडिया का प्रभावी उपयोग"
        ],
        results: [
          "निर्णायक अंतर से जीत",
          "पूर्व-चुनाव के अनुमानों को प्रभावी अभियान प्रबंधन से बदला गया",
          "भाजपा के लिए एक बड़ी सफलता"
        ]
      }
    },
    {
      id: 2,
      title: "भोपाल: डिजिटल मार्केटिंग की शक्ति से मिली ऐतिहासिक जीत",
      location: "भोपाल, मध्य प्रदेश",
      year: "2024",
      description: "2024 के लोकसभा चुनाव में, हमने भोपाल के लोकप्रिय सांसद आलोक शर्मा जी के लिए एक प्रभावी अभियान चलाया। पिछले विधानसभा चुनावों में पार्टी के औसत प्रदर्शन को देखते हुए, हमने एक नई और व्यापक रणनीति तैयार की, जिसका मुख्य फोकस डिजिटल मार्केटिंग पर था।",
      metrics: [
        { label: "कुल मतदाता", value: "23,39,411" },
        { label: "मतदान प्रतिशत", value: "64.06%" },
        { label: "जीत का अंतर", value: "8,22,431" }
      ],
      fullDetails: {
        challenge: "पार्टी के औसत प्रदर्शन को बेहतर बनाना और भारी बहुमत हासिल करना",
        strategy: [
          "डिजिटल मार्केटिंग पर केंद्रित रणनीति",
          "जमीनी हकीकत को समझना",
          "मतदाताओं तक पहुंचने के लिए डिजिटल प्लेटफॉर्म का प्रभावी इस्तेमाल",
          "व्यापक अभियान प्रबंधन"
        ],
        results: [
          "भोपाल के चुनावी इतिहास में अब तक की सबसे बड़ी जीत",
          "आलोक शर्मा जी को भारी बहुमत से लोकसभा पहुंचाया गया",
          "भोपाल के विकास के लिए पूरी लगन के साथ काम शुरू"
        ]
      }
    },
    {
      id: 3,
      title: "चांचौड़ा: 70 वर्षों की कांग्रेस विरासत को तोड़कर भाजपा की ऐतिहासिक जीत",
      location: "चांचौड़ा, मध्य प्रदेश",
      year: "2023",
      description: "मध्य प्रदेश विधानसभा चुनाव 2023 में, चांचौड़ा सीट पर भारतीय जनता पार्टी (भाजपा) की उम्मीदवार प्रियंका मीना पेंची जी  की जीत न सिर्फ एक साधारण चुनावी विजय थी, बल्कि यह 70 साल से चली आ रही कांग्रेस की मजबूत पकड़ को तोड़ने वाली एक ऐतिहासिक उपलब्धि थी।",
      metrics: [
        { label: "कुल मतदाता", value: "2,03,378" },
        { label: "मतदान प्रतिशत", value: "82.24%" },
        { label: "जीत का अंतर", value: "61,570" }
      ],
      fullDetails: {
        challenge: "70 साल से चली आ रही कांग्रेस की मजबूत पकड़ को तोड़ना",
        strategy: [
          "सटीक रणनीति और प्रभावी अभियान",
          "जमीनी स्तर पर की गई कड़ी मेहनत",
          "त्रिकोणीय मुकाबले में सुनियोजित रणनीति",
          "अभियान का सटीक क्रियान्वयन"
        ],
        results: [
          "70 साल की कांग्रेस विरासत को तोड़कर ऐतिहासिक जीत",
          "प्रियंका मीना पेंची जी  ने कुल वोटों का 56.47% हासिल किया",
          "समर्पण और सही योजना से असंभव को संभव बनाया गया"
        ]
      }
    },
    {
      id: 4,
      title: "शुजालपुर: रणनीति और जमीनी काम से मिली ऐतिहासिक जीत",
      location: "शुजालपुर, मध्य प्रदेश",
      year: "2023",
      description: "मध्य प्रदेश विधानसभा चुनाव 2023 में शुजालपुर सीट पर भारतीय जनता पार्टी (भाजपा) के प्रत्याशी श्री इंदर सिंह परमार की जीत, न केवल एक चुनावी सफलता थी, बल्कि यह सत्ता-विरोधी लहर और पिछले चुनावों के कम जीत के अंतर की चुनौती को पार करने वाली एक रणनीतिक विजय भी थी।",
      metrics: [
        { label: "कुल मतदाता", value: "2,19,000" },
        { label: "कुल मतदान", value: "1,85,257" },
        { label: "जीत का अंतर", value: "13,660" }
      ],
      fullDetails: {
        challenge: "सत्ता-विरोधी लहर और पिछले चुनावों के कम जीत के अंतर की चुनौती को पार करना",
        strategy: [
          "पारंपरिक प्रचार के साथ-साथ सूक्ष्म और लक्षित डिजिटल अभियान",
          "लाड़ली बहना योजना के डेटा का उपयोग",
          "सरकार के कल्याणकारी कार्यक्रमों से जुड़े मतदाताओं तक पहुंच",
          "प्रतिकूल परिस्थितियों में भी सफल क्रियान्वयन"
        ],
        results: [
          "2018 के चुनाव में केवल 5,623 वोट के अंतर से जीत की तुलना में 2023 में 13,660 वोटों के बड़े अंतर से जीत",
          "अभूतपूर्व वृद्धि और डिजिटल अभियानों के अभिनव उपयोग का परिणाम",
          "सही रणनीति और जमीनी स्तर पर की गई कड़ी मेहनत के साथ चुनावी समीकरणों को बदला गया"
        ]
      }
    }
  ];

  // Function to open modal
  const openModal = (story) => {
    setSelectedStory(story);
    setIsModalOpen(true);
  };

  // Function to close modal
  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedStory(null);
  };

  // Function to toggle card flip state
  const toggleFlip = (index) => {
    setFlippedCards(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };


  // Technology stack data
  const technologyStack = [
    {
      title: 'Voter Database',
      icon: 'fas fa-database',
      description: 'State-of-the-art CRM system housing 50M+ detailed voter profiles with demographic, behavioral, and voting history data for targeting and outreach',
      color: 'from-blue-500 to-indigo-600'
    },
    {
      title: 'Mobile Apps',
      icon: 'fas fa-mobile-alt',
      description: 'Custom-designed campaign applications that empower volunteers with real-time data access, canvassing tools, and seamless communication capabilities',
      color: 'from-purple-500 to-pink-600'
    },
    {
      title: 'Analytics Platform',
      icon: 'fas fa-chart-line',
      description: 'Sophisticated dashboard for real-time campaign performance monitoring, voter engagement metrics, and data-driven decision making',
      color: 'from-cyan-500 to-blue-600'
    },
    {
      title: 'WhatsApp API',
      icon: 'fab fa-whatsapp',
      description: 'Enterprise-grade automated messaging system for mass communications, personalized outreach, and strategic broadcast campaigns',
      color: 'from-green-500 to-teal-600'
    },
    {
      title: 'Video Production',
      icon: 'fas fa-video',
      description: 'Professional-grade video creation services including campaign ads, social media content, and multimedia storytelling solutions',
      color: 'from-red-500 to-orange-600'
    },
    {
      title: 'Social Media Tools',
      icon: 'fas fa-hashtag',
      description: 'Integrated multi-platform content management system for coordinated messaging across all digital channels and audience segments',
      color: 'from-yellow-500 to-amber-600'
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-blue-900 via-gray-900 to-red-900 text-white py-32">
        <div className="absolute inset-0 bg-black/30"></div>
        <div className="relative max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 text-center">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.2 }}
            className="mb-8"
          >
            <span className="inline-flex items-center space-x-3 bg-white/10 backdrop-blur-sm rounded-full px-6 py-3 mb-8">
              <span className="text-xl">🏆</span>
              <span className="font-semibold tracking-wide">POLITICAL TECHNOLOGY</span>
            </span>
          </motion.div>

          <motion.h1
            className="hero-text mb-8"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            Our Political Technology
            <span className="text-gradient-political block mt-2">Success Stories</span>
          </motion.h1>

          <motion.p
            className="text-xl text-white/90 max-w-4xl mx-auto leading-relaxed mb-12"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            Discover how our comprehensive political technology solutions have driven electoral success for 88+ campaigns across India.
            Our cutting-edge tools combine data science with strategic communication to deliver measurable results.
          </motion.p>

          <motion.div
            className="grid grid-cols-1 md:grid-cols-4 gap-8 max-w-4xl mx-auto"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
          >
            <div className="text-center">
              <div className="text-3xl font-bold text-orange-400 mb-2">88+</div>
              <div className="text-white/80">Campaigns Powered</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-white mb-2">5500+</div>
              <div className="text-white/80">Politicians Supported</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-green-400 mb-2">79%</div>
              <div className="text-white/80">Win Ratio</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-blue-400 mb-2">15+</div>
              <div className="text-white/80">States Covered</div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Advanced Technology Stack Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
          <motion.div
            className="text-center mb-16"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.2 }}
          >
            <h2 className="display-text mb-6">
              Advanced Technology
              <span className="text-gradient-political block mt-2">Stack</span>
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Cutting-edge tools and platforms designed for modern political campaigns
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {technologyStack.map((item, index) => (
              <motion.div
                key={index}
                className={`flip-card ${index % 2 === 0 ? 'flip-card-horizontal' : 'flip-card-vertical'} ${flippedCards[index] ? 'flipped' : ''}`}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.1 * index }}
                onClick={() => toggleFlip(index)}
                onTouchStart={() => toggleFlip(index)}
              >
                <div className={`flip-card-inner`}>
                  {/* Front of the card */}
                  <div className={`flip-card-front ${item.color}`}>
                    <div className="text-5xl mb-6 text-white"><i className={item.icon}></i></div>
                    <h3 className="text-2xl font-bold text-white mb-4">{item.title}</h3>
                    
                  </div>
                  
                  {/* Back of the card */}
                  <div className={`flip-card-back ${item.color}`}>
                    <div className="text-5xl mb-6 text-white"><i className={item.icon}></i></div>
                    <h3 className="text-2xl font-bold text-white mb-4">{item.title}</h3>
                    <p className="text-white text-opacity-90 leading-relaxed flex-grow">{item.description}</p>
                    
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>




      {/* Success Stories Carousel */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-8xl mx-auto px-6 sm:px-8 lg:px-12">
          <motion.div
            className="text-center mb-16"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.2 }}
          >
            <h2 className="display-text mb-2">
              Political Victory
              <span className="text-gradient-political block mt-2">Success Stories</span>
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Real electoral victories powered by our strategic expertise and technology
            </p>
          </motion.div>

          {/* Carousel Container */}
          <div className="bg-white rounded-2xl shadow-xl p-6 md:p-8">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" style={{ gridAutoRows: '1fr' }}>
              {victoryStories.map((story, index) => (
                <motion.div
                  key={story.id}
                  className="bg-gradient-to-br from-blue-50 to-white rounded-xl shadow-lg p-6 cursor-pointer border border-gray-100 hover:shadow-xl transition-all duration-300 flex flex-col h-full"
                  initial={{ opacity: 0, y: 50 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                  whileHover={{ y: -10 }}
                  onClick={() => openModal(story)}
                >
                  <div className="text-center flex flex-col flex-grow">
                    <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-r from-orange-500 to-red-600 rounded-full mb-4 mx-auto shadow-xl transform transition-transform duration-300 hover:scale-110">
                      <i className="fas fa-trophy text-3xl text-white"></i>
                    </div>
                    <h3 className="text-xl font-bold text-gray-900 mb-3 line-clamp-2">
                      {story.title}
                    </h3>
                    
                    {/* Highlighted location and year */}
                    <div className="bg-gradient-to-r from-blue-100 to-indigo-100 rounded-lg p-3 mb-4 shadow-sm">
                      <div className="flex items-center justify-center space-x-2">
                        <i className="fas fa-map-marker-alt text-blue-600"></i>
                        <p className="text-lg font-semibold text-gray-800">
                          {story.location} <span className="text-gray-400">•</span> <span className="text-blue-600">{story.year}</span>
                        </p>
                      </div>
                    </div>
                    
                    <p className="text-gray-700 text-sm line-clamp-4 mb-4 flex-grow">
                      {story.description}
                    </p>
                    
                    {/* Color-coded statistics with icons */}
                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-6">
                      {story.metrics.map((metric, idx) => (
                        <div
                          key={idx}
                          className="bg-gradient-to-br rounded-lg p-3 text-center shadow-sm"
                          style={{
                            backgroundImage: idx === 0
                              ? 'linear-gradient(to bottom right, #dbeafe, #bfdbfe)'
                              : idx === 1
                                ? 'linear-gradient(to bottom right, #dcfce7, #bbf7d0)'
                                : 'linear-gradient(to bottom right, #fef3c7, #fde68a)'
                          }}
                        >
                          <div className="flex justify-center mb-1">
                            {idx === 0 ? (
                              <i className="fas fa-users text-lg" style={{
                                color: idx === 0 ? '#1d4ed8' : idx === 1 ? '#166534' : '#854d0e'
                              }}></i>
                            ) : idx === 1 ? (
                              <i className="fas fa-vote-yea text-lg" style={{
                                color: idx === 0 ? '#1d4ed8' : idx === 1 ? '#166534' : '#854d0e'
                              }}></i>
                            ) : (
                              <i className="fas fa-percentage text-lg" style={{
                                color: idx === 0 ? '#1d4ed8' : idx === 1 ? '#166534' : '#854d0e'
                              }}></i>
                            )}
                          </div>
                          <div className="text-xl font-bold" style={{
                            color: idx === 0 ? '#1d4ed8' : idx === 1 ? '#166534' : '#854d0e'
                          }}>
                            {metric.value}
                          </div>
                          <div className="text-xs text-gray-600 mt-1">{metric.label}</div>
                        </div>
                      ))}
                    </div>
                    
                   
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Modal for Detailed View */}
      {isModalOpen && selectedStory && (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4">
          <motion.div
            className="bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.3 }}
          >
            <div className="p-6 md:p-8">
              {/* Modal Header */}
              <div className="flex justify-between items-start mb-6 pb-4 border-b border-gray-200">
                <div>
                  <div className="flex items-center mb-2">
                    <i className="fas fa-trophy text-orange-500 text-2xl mr-3"></i>
                    <h2 className="text-2xl font-bold text-gray-900">{selectedStory.title}</h2>
                  </div>
                  <div className="flex items-center text-gray-600">
                    <i className="fas fa-map-marker-alt text-blue-500 mr-2"></i>
                    <p>{selectedStory.location} • {selectedStory.year}</p>
                  </div>
                </div>
                <button
                  onClick={closeModal}
                  className="text-gray-400 hover:text-gray-600 text-2xl font-bold h-10 w-10 rounded-full flex items-center justify-center hover:bg-gray-100 transition-colors"
                >
                  <i className="fas fa-times"></i>
                </button>
              </div>

              {/* Overview Section */}
              <div className="mb-6">
                <div className="flex items-center mb-3">
                  <i className="fas fa-file-alt text-blue-500 text-xl mr-3"></i>
                  <h3 className="text-lg font-semibold text-gray-900">Campaign Overview</h3>
                </div>
                <div className="text-gray-700 leading-relaxed bg-gray-50 p-4 rounded-xl text-sm">
                  {selectedStory.description}
                </div>
              </div>

              {/* Key Metrics */}
              <div className="mb-6">
                <div className="flex items-center mb-3">
                  <i className="fas fa-chart-line text-green-500 text-xl mr-3"></i>
                  <h3 className="text-lg font-semibold text-gray-900">Key Metrics</h3>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                  {selectedStory.metrics.map((metric, index) => (
                    <div key={index} className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl p-3 text-center border border-blue-100 shadow-sm">
                      <div className="text-lg font-bold text-blue-600 mb-1">{metric.value}</div>
                      <div className="text-gray-600 text-xs">{metric.label}</div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Challenge & Strategy */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                <div className="bg-red-50 p-4 rounded-xl border border-red-100">
                  <div className="flex items-center mb-3">
                    <i className="fas fa-exclamation-triangle text-red-500 text-xl mr-3"></i>
                    <h3 className="text-lg font-semibold text-gray-900">Key Challenge</h3>
                  </div>
                  <div className="text-gray-700 text-sm">
                    {selectedStory.fullDetails.challenge}
                  </div>
                </div>
                
                <div className="bg-blue-50 p-4 rounded-xl border border-blue-100">
                  <div className="flex items-center mb-3">
                    <i className="fas fa-lightbulb text-blue-500 text-xl mr-3"></i>
                    <h3 className="text-lg font-semibold text-gray-900">Our Strategy</h3>
                  </div>
                  <ul className="space-y-2">
                    {selectedStory.fullDetails.strategy.slice(0, 3).map((item, index) => (
                      <li key={index} className="flex items-start">
                        <i className="fas fa-check-circle text-green-500 mt-1 mr-2 text-sm"></i>
                        <span className="text-gray-700 text-sm">{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              {/* Results */}
              <div className="mb-6">
                <div className="flex items-center mb-3">
                  <i className="fas fa-medal text-yellow-500 text-xl mr-3"></i>
                  <h3 className="text-lg font-semibold text-gray-900">Achieved Results</h3>
                </div>
                <div className="bg-green-50 p-4 rounded-xl border border-green-100">
                  <ul className="space-y-2">
                    {selectedStory.fullDetails.results.map((result, index) => (
                      <li key={index} className="flex items-start">
                        <i className="fas fa-trophy text-orange-500 mt-1 mr-2 text-sm"></i>
                        <span className="text-gray-700 text-sm">{result}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              {/* Close Button */}
              <div className="flex justify-end pt-4 border-t border-gray-200">
                <button
                  onClick={closeModal}
                  className="bg-gradient-to-r from-orange-500 to-red-600 hover:from-orange-600 hover:to-red-700 text-white font-bold py-2 px-5 rounded-lg transition-all duration-300 flex items-center text-sm"
                >
                  <i className="fas fa-times mr-2"></i>
                  Close
                </button>
              </div>
            </div>
          </motion.div>
        </div>
      )}








      {/* Additional Content Section */}
      <section className="py-20 bg-gray-100">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
          <motion.div
            className="text-center mb-16"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.2 }}
          >
            <h2 className="display-text mb-6">
              Driving Electoral
              <span className="text-gradient-political block mt-2">Success</span>
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Our technology solutions have powered campaigns across party lines, delivering measurable results
            </p>
          </motion.div>

          <div className="bg-white rounded-3xl shadow-2xl p-8 md:p-12">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              <div className="text-center">
                <div className="text-5xl font-bold text-jetBlue-600 mb-2">88+</div>
                <div className="text-lg text-gray-700">Campaigns Powered</div>
              </div>
              <div className="text-center">
                <div className="text-5xl font-bold text-red-600 mb-2">5500+</div>
                <div className="text-lg text-gray-700">Politicians Supported</div>
              </div>
              <div className="text-center">
                <div className="text-5xl font-bold text-green-600 mb-2">79%</div>
                <div className="text-lg text-gray-700">Win Ratio</div>
              </div>
              <div className="text-center">
                <div className="text-5xl font-bold text-purple-600 mb-2">15+</div>
                <div className="text-lg text-gray-700">States Covered</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-20 bg-gradient-to-br from-blue-900 via-gray-900 to-red-900 text-white">
        <div className="max-w-4xl mx-auto px-6 sm:px-8 lg:px-12 text-center">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.2 }}
          >
            <h2 className="display-text mb-6">
              Ready to Transform Your
              <span className="text-gradient-victory block mt-2">Campaign Technology?</span>
            </h2>
            <p className="text-xl text-white/90 mb-12 max-w-3xl mx-auto">
              Join hundreds of successful political leaders who leverage our technology for electoral victory.
              Let's discuss your campaign goals and create a customized technology strategy.
            </p>

            <div className="flex flex-col sm:flex-row gap-6 justify-center">
              <motion.button
                className="bg-gradient-to-r from-orange-500 to-red-600 hover:from-orange-600 hover:to-red-700 text-white font-bold py-4 px-8 rounded-xl transition-all duration-300 shadow-lg"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => {
                  const element = document.getElementById('contact');
                  if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                  }
                }}
              >
                Book Strategy Consultation
              </motion.button>

              <motion.button
                className="bg-white/10 backdrop-blur-sm border-2 border-white/30 text-white font-bold py-4 px-8 rounded-xl transition-all duration-300 hover:bg-white/20"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => {
                  window.open('/portfolio', '_blank');
                }}
              >
                View Success Portfolio
              </motion.button>
            </div>

            <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
              <div>
                <div className="text-2xl font-bold text-orange-400 mb-2">24/7</div>
                <div className="text-white/80">Campaign Support</div>
              </div>
              <div>
                <div className="text-2xl font-bold text-white mb-2">100%</div>
                <div className="text-white/80">Confidential Process</div>
              </div>
              <div>
                <div className="text-2xl font-bold text-green-400 mb-2">30 Days</div>
                <div className="text-white/80">Implementation Timeline</div>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default PoliticalWinsPage;
